import React, { CSSProperties } from "react";

export const ThreeDotsMenuIconSvg = ({
  color = "currentColor",
  width = "4",
  height = "18",
}: {
  color?: CSSProperties["color"];
  height?: string;
  width?: string;
}) => (
  <svg
    aria-hidden="true"
    height={height}
    width={width}
    viewBox="0 0 4 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="2" cy="2" r="2" fill={color} />
    <circle cx="2" cy="9" r="2" fill={color} />
    <circle cx="2" cy="16" r="2" fill={color} />
  </svg>
);
